import { memo, type PropsWithChildren } from "react";
import { WarningIcon } from "vega-icons";

import { cnTwMerge } from "@vega-core/utils/cnTwMerge";
import { isTruthy } from "@vega-core/utils/isTruthy";

type Props = {
  baseFont?: boolean;
  className?: string;
  fontSize?: string;
  withBottomMargin?: boolean;
  withMargin?: boolean;
  type?: "error" | "warning";
  dataTestId: string;
};

export const ValidationErrorText = memo(
  ({
    baseFont,
    children,
    className,
    fontSize,
    type = "error",
    withBottomMargin,
    withMargin,
    dataTestId,
  }: PropsWithChildren<Props>) => (
    <div
      className={cnTwMerge(
        "flex items-center text-xs font-normal",
        isTruthy(withMargin) && "mt-2",
        isTruthy(withBottomMargin) && "mb-2",
        className,
      )}
      data-error="true"
      data-testid={`${dataTestId}-error`}
    >
      <div>
        {type === "error" ? (
          <WarningIcon
            aria-hidden="true"
            className="w-5 h-5 mr-2 text-text/negative"
          />
        ) : (
          <WarningIcon className="w-5 h-5 mr-2 text-text/warning text-xs" />
        )}
      </div>
      <div
        className={cnTwMerge(
          "text-start",
          {
            "text-base": baseFont,
            "text-text/negative": type === "error",
            "text-text/warning": type === "warning",
          },
          fontSize,
        )}
      >
        {children}
      </div>
    </div>
  ),
);
